import { css } from '@/styled-system/css';

export const miniMapContainer = css({
  width: '42px',
  height: '42px',
  borderRadius: '4px',
  overflow: 'hidden',
  flexShrink: 0,
  position: 'relative',
});

export const shimmerSkeleton = css({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1,
  bgGradient: 'heroPhotoContainerBgGradient',
  backgroundSize: '2000px 100%',
  animationName: 'shimmer',
  animationDuration: '2s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
  '@media (prefers-reduced-motion: reduce)': {
    animationName: 'none',
  },
});

export const mapImageOverlay = css({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  opacity: 0,
  zIndex: 2,
  transitionProperty: 'opacity',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-in',
});

export const mapImageVisible = css({
  opacity: 1,
});

export const pinOverlay = css({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
  zIndex: 3,
  transitionProperty: 'opacity',
  transitionDuration: '300ms',
  transitionTimingFunction: 'ease-in',
});
